import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 出入金約定書/上傳
 */
const ProofDocUpload = [
    'POST',
    RouteUrlList.API_ProofDocUpload.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default ProofDocUpload;
